import { defineComponent as _defineComponent } from 'vue'
import { Studio, StudioUser, SearchParams } from '@/modules/Studios/types'
import { fetchStudioTeachers, deleteStudioTeacherById, addStudioTeacher } from '@/enitites/studio/api/endpoints'
import { ref, watch } from 'vue'
import UserChip from '@/shared/ui/chips/UserChip.vue'
import BKInput from '@/components/AppShared/BKInput.vue'
import { mdiMagnify, mdiMinusCircleOutline, mdiPlus } from '@mdi/js'
import { BKModal } from '@/shared/ui/modals'
import BKUserSelect from '@/components/BKUserSelect.vue'
import Bugsnag from '@bugsnag/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioSettingsTeachers',
  props: {
    studio: null
  },
  setup(__props: any) {

const props = __props as { studio: Studio };



const studioTeachers = ref<StudioUser[]>([])
const infiniteId = ref(Number(new Date()))
const loading = ref(false)
const showNotFound = ref(false)
const searchParams = ref<SearchParams>({
  pageNumber: 0,
  pageSize: 100,
  keyword: '',
  sortBy: 'name',
  sortDir: 'asc',
})

const infiniteHandler = async ($state: { complete: () => void; loaded: () => void }) => {
  loading.value = true
  const data = await fetchStudioTeachers(props.studio.id, searchParams.value)
  loading.value = false

  if (!Array.isArray(data)) {
    $state.complete()
    return
  }
  searchParams.value.pageNumber += 1

  studioTeachers.value = [...studioTeachers.value, ...data]
  if (!studioTeachers.value.length) showNotFound.value = true
  if (data.length < searchParams.value.pageSize) $state.complete()
  else $state.loaded()
}

const searchTimeout = ref<number | null>(null)

const showAddModal = ref(false)
const isAddingTeacher = ref(false)
const newlyAddedTeachers = ref<StudioUser[]>([])

const handleAddUser = async (user: StudioUser) => {
  isAddingTeacher.value = true

  try {
    const res = await addStudioTeacher(props.studio.id, user.id)
    if (!res) return

    studioTeachers.value.push(user)
    newlyAddedTeachers.value.push(user)
  } catch (e) {
    Bugsnag.notify(e instanceof Error ? e : new Error(String(e)), (event) => {
      event.addMetadata('studio', {
        context: 'Error adding studio teacher',
        studioId: props.studio.id,
        userId: user.id,
      })
    })
  } finally {
    isAddingTeacher.value = false
  }
}

const handleDeleteUser = async (user: StudioUser) => {
  const res = await deleteStudioTeacherById(props.studio.id, user.id)
  if (res !== 'ok') return

  studioTeachers.value = studioTeachers.value.filter((u) => u.id !== user.id)
  newlyAddedTeachers.value = newlyAddedTeachers.value.filter((u) => u.id !== user.id)
}

watch(
  () => searchParams.value.keyword,
  () => {
    if (searchTimeout.value) clearTimeout(searchTimeout.value)
    searchTimeout.value = setTimeout(() => {
      searchParams.value.pageNumber = 0
      studioTeachers.value = []
      showNotFound.value = false
      infiniteId.value += 1
      searchTimeout.value = null
    }, 600)
  }
)

return { __sfc: true,props, studioTeachers, infiniteId, loading, showNotFound, searchParams, infiniteHandler, searchTimeout, showAddModal, isAddingTeacher, newlyAddedTeachers, handleAddUser, handleDeleteUser, UserChip, BKInput, mdiMagnify, mdiMinusCircleOutline, mdiPlus, BKModal, BKUserSelect }
}

})